<script setup>
setPageTitle(PageMeta.JobTypes.preview.title)
definePage({ meta: PageMeta.JobTypes.preview.meta })

import { useJobTypesStore } from '@/@vxapp/JobTypes/useJobTypesStore'

import JobTypePreviewPage from '@/views/setup/job-types/preview/JobTypePreviewPage.vue'

const route = useRoute()
const jobTypesStore = useJobTypesStore()

watch(
  () => jobTypesStore.messagesVariables,
  async newVal => {
    //setPageTitle(jobTypesStore.messagesVariables.)
  },
  { deep: true, immediate: false }
)

/* ** */
</script>

<template>
  <section>
    <!-- Horizontal Menu / Navigation -->
    <VRow>
      <VCol cols="12">
        <HorizontalJobTypesMenu :job-type-g-u-i-d="route.params.guid" />
      </VCol>
    </VRow>

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <JobTypePreviewPage
          v-if="route.params.guid"
          :job-type-g-u-i-d="route.params.guid"
        />
      </VCol>
    </VRow>
  </section>
</template>
